import { getAuthHeaderName, getAuthHeaderPrefix } from '@/config/api/env.js'
import { getAccessToken } from '@/config/api/authStore.js'
import { getActiveWorkspaceId } from '@/store/workspaceStore'
import axiosClient from './axiosClient.js'
import { attachHeader, readHeader } from './axiosHeaders.js'

axiosClient.interceptors.request.use((config) => {
  if (!readHeader(config, 'X-Request-Id')) {
    const id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `req-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    attachHeader(config, 'X-Request-Id', id)
  }
  const token = getAccessToken()
  if (token) {
    const headerName = getAuthHeaderName()
    if (!readHeader(config, headerName)) attachHeader(config, headerName, `${getAuthHeaderPrefix()}${token}`)
  }
  const workspaceId = getActiveWorkspaceId()
  if (workspaceId && !readHeader(config, 'X-Workspace-Id')) {
    attachHeader(config, 'X-Workspace-Id', workspaceId)
  }
  return config
})
